"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Illustration = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var cloudinarize_1 = __importDefault(require("../cloudinarize"));
var illustrationUrls = {
    boyGirl: "https://res.cloudinary.com/kinside/image/upload/v1627996200/app_assets/illustration-boygirl.png",
    toys: "https://res.cloudinary.com/kinside/image/upload/v1627995900/app_assets/illustration-toys3.png",
    sun: "https://res.cloudinary.com/kinside/image/upload/v1627995900/app_assets/illustration-sun.png",
    plants: "https://res.cloudinary.com/kinside/image/upload/v1627995900/app_assets/illustration-plants.png",
    momDaughter: "https://res.cloudinary.com/kinside/image/upload/v1627995900/app_assets/illustration-mom-daughter.png",
    employee: "https://res.cloudinary.com/kinside/image/upload/v1627995900/app_assets/illustration-employee.png",
    moon: "https://res.cloudinary.com/kinside/image/upload/v1627995899/app_assets/illustration-moon.png",
    block: "https://res.cloudinary.com/kinside/image/upload/v1627996200/app_assets/kinside_app/illustration-block1.png",
    trees: "https://res.cloudinary.com/kinside/image/upload/v1627995900/app_assets/kinside_app/illustration-trees.png",
    map: "https://res.cloudinary.com/kinside/image/upload/v1627995900/app_assets/kinside_app/illustration-map.png",
    momDaughter2: "https://res.cloudinary.com/kinside/image/upload/v1627995900/app_assets/illustration-mom-daughter2.png",
    chalkboard: "https://res.cloudinary.com/kinside/image/upload/v1627995899/app_assets/kinside_app/illustration-chalkboard.png",
    child1: "https://res.cloudinary.com/kinside/image/upload/v1648078117/app_assets/illustration-child1.png",
    child2: "https://res.cloudinary.com/kinside/image/upload/v1648078117/app_assets/illustration-child2.png",
    search: "https://res.cloudinary.com/kinside/image/upload/v1648078117/app_assets/illustration-search.png",
    chair: "https://res.cloudinary.com/kinside/image/upload/v1683094463/app_assets/illustration-chair.png",
};
var filters = {
    employee: { width: 181 },
    boyGirl: { width: 213 },
    chalkboard: { width: 192 },
    map: { width: 198 },
    momDaughter: { width: 153 },
    momDaughter2: { width: 111 },
    plants: { width: 196 },
    sun: { width: 70 },
    trees: { width: 68 },
    toys: { width: 145 },
    block: { width: 185 },
    moon: { width: 182 },
    search: { width: 150 },
    child1: { width: 152 },
    child2: { width: 164 },
    chair: { width: 76 },
};
var useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        illustration: {
            display: "block",
        },
        illustration__image: {
            display: "block",
            overflow: "hidden",
            margin: 0,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "contain",
        },
        employee: {
            width: filters.employee.width,
            "& .illustration__image": {
                paddingTop: "90%",
            },
        },
        boyGirl: {
            width: filters.boyGirl.width,
            "& .illustration__image": {
                paddingTop: "96%",
            },
        },
        chalkboard: {
            width: filters.chalkboard.width,
            "& .illustration__image": {
                paddingTop: "56%",
            },
        },
        map: {
            width: filters.map.width,
            "& .illustration__image": {
                paddingTop: "68%",
            },
        },
        momDaughter: {
            width: filters.momDaughter.width,
            "& .illustration__image": {
                paddingTop: "78%",
            },
        },
        momDaughter2: {
            width: filters.momDaughter2.width,
            "& .illustration__image": {
                paddingTop: "156%",
            },
        },
        plants: {
            width: filters.plants.width,
            "& .illustration__image": {
                paddingTop: "73.4%",
            },
        },
        sun: {
            width: filters.sun.width,
            "& .illustration__image": {
                paddingTop: "94%",
            },
        },
        trees: {
            width: filters.trees.width,
            "& .illustration__image": {
                paddingTop: "94%",
            },
        },
        toys: {
            width: filters.toys.width,
            "& .illustration__image": {
                paddingTop: "98%",
            },
        },
        block: {
            width: filters.block.width,
            "& .illustration__image": {
                paddingTop: "64%",
            },
        },
        moon: {
            width: filters.moon.width,
            "& .illustration__image": {
                paddingTop: "69%",
            },
        },
        child1: {
            width: filters.child1.width,
            "& .illustration__image": {
                paddingTop: "100%",
            },
        },
        child2: {
            width: filters.child2.width,
            "& .illustration__image": {
                paddingTop: "30%",
            },
        },
        search: {
            width: filters.search.width,
            "& .illustration__image": {
                paddingTop: "30%",
            },
        },
        chair: {
            width: filters.chair.width,
            "& .illustration__image": {
                paddingTop: "94%",
            },
        },
    });
});
var Illustration = function (props) {
    var classes = useStyles(props);
    var cloudinaryUrl = cloudinarize_1.default(illustrationUrls[props.name], filters[props.name]);
    var illustrationUrl = "url(" + cloudinaryUrl + ")";
    return (react_1.default.createElement("div", { className: classes.illustration + " " + classes[props.name] + " " + props.name, style: props.width ? { width: props.width } : null },
        react_1.default.createElement("figure", { className: classes.illustration__image + " illustration__image", style: {
                backgroundImage: illustrationUrl,
            } })));
};
exports.Illustration = Illustration;
